/**
 * ContainerGroupErrorsMessage
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Message } from 'semantic-ui-react';

// Selectors
import { makeSelectContainerGroupValue } from '../../../../../../../../services/containerGroups/selectors';

interface Props {
    errors?: string[];
}

export class ContainerGroupErrorsMessage extends React.PureComponent<Props> {
    render() {
        const { errors } = this.props;
        if (!errors || !errors.length) return null;
        return (
            <Message
                error
                header="There were some errors returned from SAP"
                list={errors}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    errors: makeSelectContainerGroupValue('errors')
});

export default connect(mapStateToProps)(ContainerGroupErrorsMessage);
